'use client';
import { useAutoCollateralMigration } from '@/hooks/useAutoCollateralMigration';

/**
 * Empty component that purely runs the auto-migration hook globally.
 */
export function CollateralAutoMigrator() {
  useAutoCollateralMigration();
  return null;
}
